module.exports = __webpack_public_path__ + "img/banner_left.e6dd98a1.png";